import { Analytics, AnalyticsBrowser } from '@segment/analytics-next'
import * as React from 'react'

const SegmentContext = React.createContext<{ segmentTrack: (name: string, props: object) => void }>({
  segmentTrack: () => null,
})

const SegmentContextProvider = ({ writeKey, children }: { writeKey: string; children: React.ReactNode }) => {
  const [analytics, setAnalytics] = React.useState<Analytics | null>(null)

  React.useEffect(() => {
    if (writeKey) {
      const loadAnalytics = async () => {
        const [analyticsInstance] = await AnalyticsBrowser.load({ writeKey: writeKey })
        setAnalytics(analyticsInstance)
      }
      loadAnalytics()
    }
  }, [writeKey])

  function segmentTrack(name: string, props: object) {
    if (analytics) {
      analytics.track(name, props)
    } else {
      console.warn('Analytics ainda não foi inicializado.')
    }
  }

  const contextValue = React.useMemo(() => ({ segmentTrack }), [analytics])

  return <SegmentContext.Provider value={contextValue}>{children}</SegmentContext.Provider>
}

export { SegmentContext, SegmentContextProvider }
